(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-sectttion"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const section = document.querySelector('[data-xka-section]');
    if (!section || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const surface = section.querySelector('[data-xka-depth]');
    const portal = section.querySelector('[data-xka-portal]');
    const magneticBtn = section.querySelector('[data-xka-magnetic]');

    // Spatial Vector Coordinate Calculations for Full Viewport Matrix Distortion
    section.addEventListener('mousemove', (e) => {
      if (window.innerWidth <= 989) return;

      const rect = section.getBoundingClientRect();
      const x = (e.clientX - rect.left) / rect.width - 0.5;
      const y = (e.clientY - rect.top) / rect.height - 0.5;

      if (surface) {
        surface.style.transform = `rotateX(${y * -8}deg) rotateY(${x * 8}deg) translateZ(0px)`;
        surface.style.transition = 'transform 0.15s ease-out';
      }

      if (portal) {
        portal.style.transform = `translate3d(${x * 25}px, ${y * 25}px, 20px) rotateX(${y * 4}deg) rotateY(${x * -4}deg)`;
        portal.style.transition = 'transform 0.2s ease-out';
      }
    });

    section.addEventListener('mouseleave', () => {
      if (surface) {
        surface.style.transform = 'rotateX(0deg) rotateY(0deg) translateZ(0px)';
        surface.style.transition = 'transform 0.8s cubic-bezier(0.16, 1, 0.3, 1)';
      }
      if (portal) {
        portal.style.transform = 'translate3d(0px, 0px, 0px) rotateX(0deg) rotateY(0deg)';
        portal.style.transition = 'transform 0.8s cubic-bezier(0.16, 1, 0.3, 1)';
      }
    });

    // Button Engine Field
    if (magneticBtn) {
      magneticBtn.addEventListener('mousemove', (e) => {
        const bRect = magneticBtn.getBoundingClientRect();
        const bX = e.clientX - bRect.left - bRect.width / 2;
        const bY = e.clientY - bRect.top - bRect.height / 2;
        magneticBtn.style.transform = `translate(${bX * 0.35}px, ${bY * 0.35}px)`;
        magneticBtn.style.transition = 'transform 0.08s ease-out';
      });

      magneticBtn.addEventListener('mouseleave', () => {
        magneticBtn.style.transform = 'translate(0px, 0px)';
        magneticBtn.style.transition = 'transform 0.4s cubic-bezier(0.16, 1, 0.3, 1)';
      });
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
